import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

export interface IServiceOrderLineExistenceInfo {
    lineNumber: number;       // CS-side identifier within the service order; 0 for D365-only rows
    itemNumber: string;
    inventoryLotId: string;   // D365-side identifier; "" for CS-only rows
    existsInCS: boolean;
    existsInD365: boolean;
}

const getServiceOrderLineExistence = async (
    payload: IReadVerbPayload,
): Promise<IServiceOrderLineExistenceInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<IServiceOrderLineExistenceInfo[]>(
        `/ServiceOrder/ServiceOrderLineExistenceD365`,
        payload,
    );
    return response.data;
};

export const useGetServiceOrderLineExistence = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const salesOrderNumber = payload.keys.salesOrderNumber as string;
    const serviceOrderID = payload.keys.serviceOrderID as number;

    return useQuery<IServiceOrderLineExistenceInfo[]>({
        queryKey: [
            "GetServiceOrderLineExistenceD365",
            {
                serviceOrderID: serviceOrderID ?? null,
                dataAreaId: dataAreaId ?? null,
                salesOrderNumber: salesOrderNumber ?? null,
            },
        ],
        queryFn: () => {
            if (!serviceOrderID || serviceOrderID <= 0 || !dataAreaId || !salesOrderNumber) {
                throw new Error(
                    "Invalid params for GetServiceOrderLineExistenceD365",
                );
            }
            return getServiceOrderLineExistence(payload);
        },
        enabled:
            Boolean(
                !serviceOrderID || serviceOrderID <= 0 || !dataAreaId || !salesOrderNumber,
            ) === false,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
